<template>
  <div class="general-wrapper">
      <div class="header">
          <h2 class="qrw-heading-xl">INSIDE lite</h2>
      </div>
      <div class="center-container justify-content-start px-50">
          <OrderStickersPanel class="iqos-empty" in_lite/>
      </div>
  </div>
</template>

<script>
import OrderStickersPanel from "@/components/inside/OrderStickersPanel.vue"

export default {
    components: {
        OrderStickersPanel
    }
}
</script>

<style>

</style>